import { User } from '@goldcast/api/backend';

import { State, CheckInStaffMap } from '@/studio/checkInStaff/store';

const mutations = {
  setCheckInStaff(state: State, checkInStaff: CheckInStaffMap) {
    state.checkInStaff = checkInStaff;
  },
  setIsLoadingCheckInStaff(state: State, isLoadingCheckInStaff: boolean) {
    state.isLoadingCheckInStaff = isLoadingCheckInStaff;
  },
  deleteCheckInStaff(state: State, checkInStaffId: number) {
    const checkInStaff = { ...state.checkInStaff };
    delete checkInStaff[checkInStaffId];
    state.checkInStaff = checkInStaff;
  },
  updateCheckInStaff(
    state: State,
    { checkInStaffId, updatedCheckInStaffUser }: { checkInStaffId: number; updatedCheckInStaffUser: User }
  ) {
    state.checkInStaff = {
      ...state.checkInStaff,
      [checkInStaffId]: {
        ...state.checkInStaff[checkInStaffId],
        user: updatedCheckInStaffUser
      }
    };
  }
};

export default mutations;
